
import { AppRouter } from "@/app/AppRouter.tsx";
import { Providers } from "@/app/Providers.tsx";
import { useSharedTranslation } from "@workleap-ai/shared";

export const App = () => {
    const { tShared } = useSharedTranslation();

    return (
        <>
            <title>{tShared("workleapAi")}</title>
            <Providers>
                <AppRouter />
            </Providers>
        </>
    );
};
